import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { useI18n } from "../i18n";
import { usePlanPreview } from "../context/PlanPreviewContext";
import { CreditCard, Sparkles, ArrowRight } from "lucide-react";

const PLAN_LABEL = {
  free: "Free", start: "Start", pro: "Pro", premium: "Premium",
  premium_accountant: "Premium", business: "Pro", private_basic: "Pro",
  independent_basic: "Pro", independent_pro: "Pro",
};

const T = {
  es: { your: "Tu plan", trial: "Prueba", daysLeft: "días restantes", trialEnd: "Fin de prueba", renew: "Renovación", upgrade: "Mejorar plan", soon: "Beta · prueba gratuita de 30 días" },
  en: { your: "Your plan", trial: "Trial", daysLeft: "days left", trialEnd: "Trial ends", renew: "Renews", upgrade: "Upgrade plan", soon: "Beta · 30-day free trial" },
  fr: { your: "Votre offre", trial: "Essai", daysLeft: "jours restants", trialEnd: "Fin d'essai", renew: "Renouvellement", upgrade: "Améliorer l'offre", soon: "Bêta · essai gratuit de 30 jours" },
  pt: { your: "O teu plano", trial: "Teste", daysLeft: "dias restantes", trialEnd: "Fim do teste", renew: "Renovação", upgrade: "Melhorar plano", soon: "Beta · teste gratuito de 30 dias" },
  it: { your: "Il tuo piano", trial: "Prova", daysLeft: "giorni rimasti", trialEnd: "Fine prova", renew: "Rinnovo", upgrade: "Migliora piano", soon: "Beta · prova gratuita di 30 giorni" },
};

export const PlanSummary = () => {
  const { locale } = useI18n();
  const { previewPlan } = usePlanPreview();
  const L = T[locale] || T.es;
  const [d, setD] = useState(null);
  const [soon, setSoon] = useState(false);

  useEffect(() => {
    api.get("/subscription").then((r) => setD(r.data)).catch(() => {});
    api.get("/billing/plans").then((r) => setSoon(!r.data.enabled)).catch(() => {});
  }, []);

  if (!d) return null;
  const sub = d.subscription || {};
  const inTrial = !!d.in_trial;
  const planLabel = previewPlan
    ? (PLAN_LABEL[previewPlan] || "Free")
    : (inTrial ? `${L.trial} · Pro` : (PLAN_LABEL[d.effective_plan] || "Free"));
  const end = inTrial ? sub.trial_end : (sub.current_period_end || sub.stripe_current_period_end);
  let daysLeft = null, renew = null;
  if (end) {
    try {
      const dt = new Date(end);
      if (!isNaN(dt)) { renew = dt.toISOString().slice(0, 10); daysLeft = Math.max(0, Math.ceil((dt - new Date()) / 86400000)); }
    } catch (e) { /* noop */ }
  }

  return (
    <div data-testid="plan-summary" className="bg-white border border-[#D5E7E5] rounded-lg p-4 mb-6 flex flex-wrap items-center justify-between gap-3">
      <div className="flex items-center gap-3">
        <div className="w-9 h-9 rounded-full bg-[#0299A0]/10 flex items-center justify-center">
          {inTrial ? <Sparkles size={18} className="text-[#0299A0]" /> : <CreditCard size={18} className="text-[#0299A0]" />}
        </div>
        <div>
          <div className="text-xs text-[#5F8588]">{L.your}</div>
          <div className="text-base font-bold text-[#075E62]" data-testid="plan-summary-name">{planLabel}</div>
          <div className="text-xs text-[#5F8588]" data-testid="plan-summary-meta">
            {inTrial && daysLeft != null && <span>{L.trial}: {daysLeft} {L.daysLeft}</span>}
            {renew && <span>{inTrial ? " · " : ""}{inTrial ? L.trialEnd : L.renew}: {renew}</span>}
          </div>
        </div>
      </div>
      {soon ? (
        <span data-testid="plan-upgrade-soon" className="text-sm px-4 py-2 rounded-full bg-[#EAF3F1] text-[#5F8588] cursor-default">{L.soon}</span>
      ) : (
        <Link to="/subscription" data-testid="plan-upgrade-btn" className="text-sm px-4 py-2 rounded-full bg-[#0299A0] text-white hover:bg-[#077c82] inline-flex items-center gap-1">{L.upgrade} <ArrowRight size={14} /></Link>
      )}
    </div>
  );
};
